import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem,Image } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns/format";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import { modalAtom } from "../../../context";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { AnyAaaaRecord } from "dns";



const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function NotRegisteredStudentReport() {
  const [hide,set_hide] = useState<boolean>(true);
const [activeIndex] = useAtom(indexAtom);
const queryClient = useQueryClient();
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const [date_range,set_date_range] = useState<any>({start:'',end:''});
  const [selected_status,set_selected_status] = useState<null | string>(null);
  const [selected_level,set_selected_level] = useState<null | string>(null);
  const [selected_examperiod,set_selected_examperiod] = useState<null | string>(null);


  const {data:allLevel} = useQuery(['exemption'],{
    queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
     
      return data.data.Data;
    },
  });

  // const {data:notregisteredStudentReportList,isLoading} = useQuery(['registered-student'],{
  //   queryFn:async()=>await apiCall().get(`/Exam/GetAllNotRegisteredStudent?PageNumber=1&PageSize=100`),
  //   select(data:any){
  //     //console.log(data,'registeredstudent')
  //   return data.data.reportItems;
  //   }
  // });
   const { data: notregisteredStudentReportList, isLoading } = useQuery(
        ["all-student"],
        async () => {
          try {
            // Fetch first page
        const firstPageResponse = await apiCall().get(
              `Exam/GetAllNotRegisteredStudent?PageNumber=1&PageSize=100`
            );
            let totalPages = firstPageResponse.data?.PageCount || 1;
            let allData = firstPageResponse.data?.reportItems || [];
            console.log("Fetched first page:", allData.length);
            console.log("Total Pages:", totalPages);
            // Fetch remaining pages
            if (totalPages > 1) {
              const fetchPromises = [];
              for (let page = 2; page <= totalPages; page++) {
                fetchPromises.push(
                  apiCall().get(
                    `Exam/GetAllNotRegisteredStudent?PageNumber=${page}&PageSize=100`
                  )
                );
              }
      
              const responses = await Promise.all(fetchPromises);
              responses.forEach((res, index) => {
                console.log(`Page ${index + 2}:`, res.data?.reportItems.length);
                allData = [...allData, ...(res.data?.reportItems || [])];
              });
            }
      
            console.log("Final Combined Data:", allData.length);
            return allData;
          } catch (error) {
            console.error("Error fetching students:", error);
            return [];
          }
        },
        {
          select: (data: any) => data, // Ensure all data is returned
        }
      );
  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(allLevel);

  
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(notregisteredStudentReportList)
    }
    else set_filter_data(notregisteredStudentReportList)
  }

  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  useEffect(()=>{
    if(selected_status){
      let data = notregisteredStudentReportList.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase);
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(notregisteredStudentReportList);
    }
  },[selected_status])

  useEffect(()=>{
    set_filter_data(notregisteredStudentReportList)
  },[notregisteredStudentReportList])

  const handleFilter = (e:any) =>{
    const value = Number(e?.target?.value || 0);
    console.log(value)
    if(value || !isNaN(value)){
       let data = notregisteredStudentReportList?.filter((eData:any) => {
        console.log(eData.Level,'Level')
        return eData.Level.Id == value});
      if(data.length > 0){
        set_selected_level(data[0].Level.Id)
      }
      set_filter_data(data && data.length > 0 ?data : notregisteredStudentReportList)
    }
    else{
      set_filter_data(notregisteredStudentReportList) 
    }

  } 

  const handleFilter2 = (value:string = '') =>{
    if(value){
       let data = notregisteredStudentReportList?.filter((eData:any) => {
        //console.log(eData.Level,'Level')
        return eData.ExamPeriod == value});
      if(data.length > 0){
        set_selected_examperiod(data[0]?.ExamPeriod)
      }
      set_filter_data(data && data.length > 0 ?data : notregisteredStudentReportList)
    }
    else{
      set_filter_data(notregisteredStudentReportList) 
    }

  }

  
  const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
      mutationKey:[],
      mutationFn:async ()=> {
        const period_id:AnyAaaaRecord = allExamPeriod.find((e:any) => e.ExamName === selected_examperiod || 'empty')?.Id || ''; 
        const url = `/ExamReport/downloadAllNotRegisteredStudentReport?&startDate=${date_range.start || '1909-08-13'}&endDate=${date_range.end || '2100-08-13'}&ExamPeriodId=${period_id}&LevelId=${selected_level}`,method = "POST",body = {},config = {},download = true;
        return await downloadApi(url,method,body,config,download)
  
      },
      onSuccess:async(data:any)=>{
        //initial the download 
        console.log(data,'download data')
        let file = data;
       
        if(file){
          
          const url = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "NotRegistered Student-report.xlsx");
          document.body.appendChild(link);
          link.click();
          console.log(file,'data')
          set_notification({
            type:'success',
            message:data?.data?.Message || 'NotRegistered Report downloaded Successfully'
          })
          set_Nopen(true);
        }
        else{
          set_notification({
            type:'error',
            message:'Oooops! Error Occured trying to download file'
          })
          set_Nopen(true);
        }
        
      },
      onError(error:any, variables, context) {
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
  
    } )

  return (
    <>
   {isLoading?<Loader />:

    <Box>
      <TopDisplay label="Not Registered Student Report" button_array={[
        
          <Button  color="var(--white-color)" 
          bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
          
          onClick={()=>handleDownload()} disabled={isDownloading}
        >{isDownloading?" DownLoading....":'Download NotRegisterd Student Report'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Level" width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)"onChange={handleFilter} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
            <Select placeholder='Exam Period' width="140px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilter2(e.target.value)}
                name="ExamPeriodId"
              >
               {allExamPeriod && allExamPeriod.length > 0 ?
                  allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                :''}
              </Select>
          <DateFilter text="Date Range" onChange={set_date_range} />
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Not-Registered Student Report</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
        {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
        <Table size='sm'>
          <Thead>
          <Tr >
                  <Th sx={HeadStyle}>StudentNo</Th>
                  <Th sx={HeadStyle}>First Name</Th>
                  <Th sx={HeadStyle}>Last Name</Th>
                  <Th sx={HeadStyle}>Email</Th>
                  {/* <Th sx={HeadStyle}>Subjects</Th> */}
                  {/* <Th sx={HeadStyle}>Study Cent.</Th> */}
                  {/* <Th sx={HeadStyle}>Last Exam</Th> */}
                  <Th sx={HeadStyle}>Level</Th>
                  <Th sx={HeadStyle}>ExamPeriod</Th>
                  {/* <Th sx={HeadStyle}>Amount</Th> */}
                  <Th sx={HeadStyle}>Phone</Th>
                  <Th sx={HeadStyle}>Reg.Date</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
          </Thead>
          <Tbody>
          {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.SN}>
                  <Td sx={DataStyle}>{eCandidate?.StudentNo || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate?.FirstName || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate?.LastName || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate.Email || 'N/A'}</Td>
                  {/* <Td sx={DataStyle}>
                    {eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',')?.length > 35?eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',').slice(0,31)+' ...':eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',') ||'N/A'}
                  </Td> */}
                  {/* <Td sx={DataStyle}>{eCandidate?.StudyCenter?.Name || 'N/A'}</Td> */}
                  {/* <Td sx={DataStyle}>{eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',')?.length > 35?eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',').slice(0,31)+' ...':eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',') || 'N/A'}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.Level?eCandidate.Level.ExemptionName:'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate.ExamPeriod || 'N/A'}</Td>
                  {/* <Td sx={DataStyle}>{eCandidate.Amount}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.PhoneNumber}</Td>
                  <Td sx={DataStyle}>{format(new Date(eCandidate.RegistrationDate), "dd/MM/yyyy")}</Td>
                  <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                  <div className={activeIndex === index?'active':''}>
                  <Option {...{index,candidate:eCandidate}}/>
                  </div>
                  </Td>
                </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No NotRegistered Student'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  useEffect(()=>{
    set_new_level(candidate?.Level?.Id)
  },[])



  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Flex align="center" gap="20px">
      <Flex flexDir="column">
        <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading>
        <Text>Student</Text>
        <Text>ID: {props.candidate.Subjects.at(0).StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="repeat(3,1fr)"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level?.ExemptionName}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">ExamPeriod</Text>
        <Text fontWeight="500">{props.candidate.ExamPeriod || 'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
        <Text fontWeight="500">{props.candidate.StudyCenter || 'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)"> Registration Date</Text>
        <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
        <Text fontWeight="500">{props.candidate.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
        <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate.Address}</Text>
      </GridItem>
    </Grid>
  </Flex>
  )}
